import React from "react";
import DocumentTable from "~/components/document-table/DocumentTable";
import "./attachments.scss";

const AttachmentTable = ({
  formatDate,
  processAttachments,
  loadingAttachments,
  rows,
  onPageChange,
  first,
  showTypeColumn = true,
  handleAttachmentDelete,
  isPayslipFolder = false,
  relatedType = "",
  relatedId = "",
  isFilterApplied,
  totalRecords,
  onSortOrderChange,
  onRefetch,
  nameSubtext,
}) => (
  <div className="attachments__body">
    <DocumentTable
      value={processAttachments ?? []}
      loading={loadingAttachments}
      formatDate={formatDate}
      onDelete={handleAttachmentDelete}
      relatedId={relatedId}
      relatedType={relatedType}
      totalRecords={totalRecords}
      rows={rows}
      first={first}
      onPageChange={onPageChange}
      onSortOrderChange={onSortOrderChange}
      isFilterApplied={isFilterApplied}
      isPayslipFolder={isPayslipFolder}
      emptyMessage="No files found"
      onRefetch={onRefetch}
      nameSubtext={nameSubtext}
    />
  </div>
);

export default AttachmentTable;
